import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash, FaArrowLeft } from "react-icons/fa";
import { defaultImg, leftArrow, vehicle } from "../../common/Assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../Components/Header";
import { BASE_URL, URLS } from "../../Services/Constant";
import { post, put } from "../../Services/ApiHandler";
import toast from "react-hot-toast";

const AddContact = () => {
  const navigation = useNavigate();
  const location = useLocation();
  console.log("location", location);
  const [image, setImage] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const data = location?.state?.data;
  console.log("data", data);
  const type = location?.state?.type;
  console.log("type", type);

  const [form, setForm] = useState({
    persion_code: "",
    name: "",
    email: "",
    mobile: "",
  });

  //   const [errors, setErrors] = useState({
  //     persion_code: "",
  //     name: "",
  //     email: "",
  //     mobile: "",
  //   });

  //   const validate = () => {
  //     let newErrors = {};

  //     if (!form.persion_code.trim()) {
  //       newErrors.persion_code = "Person ID is required";
  //     }

  //     if (!form.name.trim()) {
  //       newErrors.name = "Name is required";
  //     }

  //     if (!form.mobile.trim()) {
  //       newErrors.mobile = "Mobile number is required";
  //     } else if (!/^[6-9]\d{9}$/.test(form.mobile)) {
  //       newErrors.mobile = "Enter valid 10-digit mobile number";
  //     }

  //     if (!form.email.trim()) {
  //       newErrors.email = "Email is required";
  //     } else if (!/^\S+@\S+\.\S+$/.test(form.email)) {
  //       newErrors.email = "Enter valid email";
  //     }

  //     setErrors(newErrors);

  //     return Object.keys(newErrors).length === 0;
  //   };

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  useEffect(() => {
    if (data) {
      setForm({
        persion_code: data?.persion_code || "",
        name: data?.name || "",
        email: data?.email || "",
        mobile: data?.mobile || "",
      });
    }

    if (type === "view") {
      setIsEdit(false);
    } else {
      setIsEdit(true);
    }
  }, [data, type]);

  const handleSave = async () => {
    //  if (!validate()) return;
    if (!form.persion_code.trim()) {
      toast.error("Person ID is required");
      return;
    }

    if (!form.name.trim()) {
      toast.error("Name is required");
      return;
    }

    if (!form.mobile.trim()) {
      toast.error("Mobile number is required");
      return;
    } else if (!/^[6-9]\d{9}$/.test(form.mobile)) {
      toast.error("Enter valid 10-digit mobile number");
      return;
    }

    if (!form.email.trim()) {
      toast.error("Email is required");
      return;
    } else if (!/^\S+@\S+\.\S+$/.test(form.email)) {
      toast.error("Enter valid email");
      return;
    }

    const payload = new FormData();
    payload.append("persion_code", form.persion_code);
    payload.append("name", form.name);
    payload.append("email", form.email);
    payload.append("mobile", form.mobile);

    try {
      setIsLoading(true);
      if (type === "add") {
        const res = await post(URLS.CONTACTS_ADD, payload);
        if (res?.status === "success") {
          setIsLoading(false);
          toast.success(res.message || "Added successfully");
          navigation(-1);
        }
      } else {
        const res = await put(
          `${URLS.CONTACTS__EDIT}${data?.persion_code}/`,
          payload,
        );
        //   const res = await put(`${URLS.CONTACTS__EDIT}1/`, payload);
        //   const res = await put(`${URLS.CONTACTS__EDIT}${data?.id}/`, payload);
        if (res?.status === "success") {
          setIsLoading(false);
          toast.success(res.message || "Updated successfully");
          navigation(-1);
        }
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <div className="add-admin-container">
        {/* Header */}
        <div onClick={() => navigation(-1)} className="admin-header">
          <img src={leftArrow} className="back-icon-arrow" />
          <h2>Contact Us</h2>
        </div>
        {/* <div className="image-list">
                    {image ? (
                        <div className="image-card">
                            <img src={image.preview} alt="vehicle" />

                            <button className="remove-btn" onClick={removeImage}>
                                ×
                            </button>
                        </div>
                    ) : (
                        <label className="upload-box">
                            <img src={defaultImg} className="imageSize" alt="vehicle" />
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                                hidden
                                disabled={!isEdit}

                            />
                        </label>
                    )}
                </div> */}
        {/* Form */}
        <div className="admin-form">
          {/* Row 1 */}
          <div className="form-groups">
            <label>Person ID</label>
            <input
              type="text"
              placeholder="Enter Person ID"
              value={form.persion_code}
              onChange={(e) => handleChange("persion_code", e.target.value)}
              readOnly={!isEdit}
            />
          </div>

          <div className="form-groups">
            <label>Admin Name</label>
            <input
              type="text"
              value={form.name}
              placeholder="Enter Admin Name"
              onChange={(e) => handleChange("name", e.target.value)}
              readOnly={!isEdit}
            />
          </div>

          {/* Row 2 */}
          <div className="form-groups">
            <label>Mobile Number</label>
            <input
              type="text"
              maxLength={10}
              placeholder="Enter mobile number"
              value={form.mobile}
              onChange={(e) =>
                { 
                const value = e.target.value;
               
    // allow only digits
    if (/^\d*$/.test(value)) {
                    handleChange("mobile", e.target.value)
                }}
            }
              readOnly={!isEdit}
            />
          </div>
          <div className="form-groups">
            <label>Email ID</label>
            <input
              type="text"
              value={form.email}
              placeholder="Enter Email ID"
              onChange={(e) => handleChange("email", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="admin-actions ">
          {type === "view" && !isEdit && (
            <button onClick={() => setIsEdit(true)} className="edit-btn">
              Edit
            </button>
          )}

          {(type === "add" || isEdit) && (
            <button onClick={handleSave} className="save-btn">
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                </>
              ) : (
                "Save"
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddContact;
